import { TLanguage, TReportType } from 'contexts/app-context/types'
import { TReportStatus } from 'pages/your-personal-data/types/YourPersonalData.types'
import { Relatorio, RelatorioStatus, TipoRelatorio } from 'common/types'

import { Report } from '../../../types/YourPersonalData.types'

const brRequestTypeToRequestTypeMapper: Record<TipoRelatorio, TReportType> = {
  [TipoRelatorio.ACESSO]: 'DATA_ACCESS',
  [TipoRelatorio.COMPARTILHAMENTO]: 'DATA_SHARING',
  [TipoRelatorio.PORTABILIDADE]: 'DATA_PORTABILITY',
  [TipoRelatorio.TRATAMENTO_DADOS]: 'DATA_TREATMENT',
}

const brStatusToStatusMapper: Record<RelatorioStatus, TReportStatus> = {
  EM_ANALISE: 'IN_ANALYSIS',
  DADOS_NAO_ENCONTRADOS: 'DATA_NOT_FOUND',
  ERRO_EXECUCAO: 'EXECUTION_ERROR',
  ERRO_NAO_PERTURBE: 'EXECUTION_ERROR',
  CONCLUIDA: 'COMPLETED',
  COMPLETA: 'COMPLETED',
  FECHADA: 'CLOSED',
  LIBERADA: 'COMPLETED',
  AGUARDANDO_EXECUCAO: 'IN_ANALYSIS',
  BLACKLIST: 'COMPLETED',
  BLOQUEADO: 'COMPLETED',
  NAO_BLOQUEADO: 'COMPLETED',
}

export const brReportToReportMapper = (report: Relatorio): Report => ({
  requestDate: report.dataSolicitacao,
  changeDate: report.dataAlteracao,
  trackNumber: report.trackNumber,
  clienteId: report.cpf,
  requestType: brRequestTypeToRequestTypeMapper[report.tipoSolicitacao],
  status: brStatusToStatusMapper[report.status],
})

export const reportTypeToFriendlyNameMapper: Record<TReportType, Record<TLanguage, string>> = {
  DATA_SHARING: {
    'en-US': 'Data sharing report',
    'es-ES': 'Informe de intercambio de datos',
    'pt-BR': 'Relatório de compartilhamento de dados',
  },
  DATA_PORTABILITY: {
    'en-US': 'Data portability report',
    'es-ES': 'Informe de portabilidad de datos',
    'pt-BR': 'Relatório de portabilidade de dados',
  },
  DATA_TREATMENT: {
    'en-US': 'Data treatment confirmation report',
    'es-ES': 'Informe de confirmación de tratamiento de datos',
    'pt-BR': 'Relatório de confirmação de tratamento de dados',
  },
  DATA_ACCESS: {
    'en-US': 'Data access report',
    'es-ES': 'Informe de acceso a datos',
    'pt-BR': 'Relatório de acesso aos dados',
  },
}

export const reportStatusToFriendlyStatusMapper: Record<
  TReportStatus,
  Record<TLanguage, string>
> = {
  IN_ANALYSIS: {
    'en-US': 'Report under analysis',
    'es-ES': 'Informe en análisis',
    'pt-BR': 'Relatório em análise',
  },
  DATA_NOT_FOUND: {
    'en-US': 'Data not found',
    'es-ES': 'Datos no encontrados',
    'pt-BR': 'Dados não encontrados',
  },
  EXECUTION_ERROR: {
    'en-US': 'Processing error',
    'es-ES': 'Error de procesamiento',
    'pt-BR': 'Erro de processamento',
  },
  COMPLETED: {
    'en-US': 'Report completed',
    'es-ES': 'Informe completado',
    'pt-BR': 'Relatório concluído',
  },
  CLOSED: {
    'en-US': 'Report closed',
    'es-ES': 'Informe cerrado',
    'pt-BR': 'Relatório encerrado',
  },
}

export enum REPORT_HISTORY_TABS_ID {
  AVAILABLE = 0,
  REQUESTED = 1,
}
